export default __webpack_public_path__ + "static/media/carousel-2.50e6b4e1.jpg";